"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spinnerVariant = exports.progressTheme = void 0;
const component_theme_1 = require("@clds/component-theme");
exports.progressTheme = (0, component_theme_1.createTheme)({
    spinnerVariant: {
        thin: 8,
        thick: 2.5,
    },
});
exports.spinnerVariant = (0, component_theme_1.createVariant)((props) => 
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
exports.progressTheme.spinnerVariant[props.spinnerVariant || 'thin']);
//# sourceMappingURL=theme.js.map